import React, { useState, useRef } from "react";

const AttachPrescription = ({ setPrescription, prescription }) => {
  // Verification method: "upload" for digital file upload, "physical" for hard copy verification.
  const [verificationMethod, setVerificationMethod] = useState("upload");
  const [selectedFile, setSelectedFile] = useState(null);
  const [physicalVerified, setPhysicalVerified] = useState(false);
  const [sellerName, setSellerName] = useState("");
  const fileInputRef = useRef(null);

  // Trigger file input click when button is pressed.
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  // Handle file change and create a preview URL.
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a temporary URL for the selected file.
      setSelectedFile(URL.createObjectURL(file));
      // You can also store the file object if you need to upload it later.
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 mt-6">
      <h2 className="text-xl font-bold mb-4">Verification Required</h2>

      {/* Select Prescription Verification Method */}
      <div className="mb-4">
        <p className="font-semibold mb-2">Prescription Verification Method:</p>
        {/* <div className="flex items-center mb-2">
          <input
            type="radio"
            id="uploadMethod"
            name="verificationMethod"
            value="upload"
            checked={verificationMethod === "upload"}
            onChange={(e) => setVerificationMethod(e.target.value)}
            className="mr-2"
          />
          <label htmlFor="uploadMethod" className="text-gray-700">
            Upload Prescription
          </label>
        </div> */}
        <div className="flex items-center">
          <input
            type="radio"
            id="physicalMethod"
            name="verificationMethod"
            value="physical"
            checked={verificationMethod === "physical"}
            onChange={(e) => setVerificationMethod(e.target.value)}
            className="mr-2"
          />
          <label htmlFor="physicalMethod" className="text-gray-700">
            Verified Physical Copy (Prescription seen within last 15 days)
          </label>
        </div>
      </div>

      {/* Physical Verification Section */}
      {verificationMethod === "physical" && (
        <div className="mt-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="physicalVerified"
              checked={physicalVerified}
              onChange={(e) => {
                setPrescription({
                  ...prescription,
                  is_physically_verified: e.target.checked,
                });
                setPhysicalVerified(e.target.checked);
              }}
              className="mr-2"
            />
            <label htmlFor="physicalVerified" className="text-gray-700">
              I confirm that I have seen the physical copy of the prescription,
              and it is valid (dated within the last 15 days). I have collected
              the hard copy from the patient.
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default AttachPrescription;
